import { render, staticRenderFns } from "./RadioType.vue?vue&type=template&id=7afc56e6&scoped=true&"
import script from "./RadioType.vue?vue&type=script&lang=js&"
export * from "./RadioType.vue?vue&type=script&lang=js&"
import style0 from "./RadioType.vue?vue&type=style&index=0&id=7afc56e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afc56e6",
  null
  
)

export default component.exports